import { render, staticRenderFns } from "./AddEventIntro.vue?vue&type=template&id=380d7c56&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventIntro.vue"
export default component.exports